export default __webpack_public_path__ + "static/sol-section-4-img-905ac2b20dc3fa86cbf9e0ddd4a2da4c.png";